import { render } from "./Page19.vue?vue&type=template&id=325c9401"
import script from "./Page19.vue?vue&type=script&lang=js"
export * from "./Page19.vue?vue&type=script&lang=js"

import "./Page19.vue?vue&type=style&index=0&id=325c9401&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__